module.exports = __webpack_public_path__ + "media/images/sort_none-343d55cc6863541277190564e60b93cd.png";